<template>
  <div class="form_box">
    <Crumbs style="margin-bottom: 37px;" :pathName="$t('register.register')" />
    <div v-loading="isClickBtn">
      <div class="form_box_item">
        <div class="item_title">{{ $t("register.account_info") }}</div>
        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t("register.user_name") }}</span>
          </div>
          <div>
            <el-input v-model="registerForm.loginName" :placeholder="$t('register.enter_user_name')" clearable
              @input="checkRegisterInfo(0)"></el-input>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[0]">
            {{ checkLoginNameMsg }}
          </div>
        </div>
        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t('register.password') }}</span>
          </div>
          <div>
            <el-input v-model="registerForm.password" :placeholder="$t('register.enter_password')" clearable
              @input="checkRegisterInfo(1)" show-password></el-input>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[1]">
            {{ checkpPasswordMsg }}
          </div>
        </div>
        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t('register.confirm_password') }}</span>
          </div>
          <div>
            <el-input v-model="registerForm.confirmPassword" :placeholder="$t('register.enter_confirm_password')"
              clearable @input="checkRegisterInfo(2)" show-password></el-input>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[2]">
            {{ checkpPasswordMsg2 }}
          </div>
        </div>
      </div>
      <div class="form_box_item">
        <div class="item_title">{{ $t('register.enterprise_information') }}</div>
        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t('register.company_name') }}</span>
          </div>
          <div>
            <el-input v-model="registerForm.companyName" :placeholder="$t('register.enter_company_name')" clearable
              @input="checkRegisterInfo(3)"></el-input>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[3]">
            {{ checkCompanyMsg }}
          </div>
        </div>

        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t('register.city') }}</span>
          </div>
          <div>
            <div class="city_sel_group">
              <el-select v-model="registerForm.country" filterable @change="changeCity($event, 1)" placeholder="国家">
                <el-option v-for="(countryItem, i) in countries" :key="i" :label="countryItem.label"
                  :value="countryItem.label">
                </el-option>
              </el-select>
              <el-select v-model="registerForm.province" filterable @change="changeCity($event, 2)" placeholder="省份">
                <el-option v-for="(provinceItem, i) in provinces" :key="i" :label="provinceItem.label"
                  :value="provinceItem.label">
                </el-option>
              </el-select>
              <el-select v-model="registerForm.city" filterable placeholder="城市" @change="checkRegisterInfo(4)">
                <el-option v-for="(cityItem, i) in cities" :key="i" :label="cityItem.label" :value="cityItem.label">
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[4]">
            {{ checkCityMgs }}
          </div>
        </div>

        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t('register.business_license') }}</span>
          </div>
          <div>
            <div class="upload-div">
              <div v-if="imgUrl2">
                <img :src="imgUrl2" class="upload-img" />
                <i class="close-img-btn el-icon-close" @click="closeImg(2)"></i>
              </div>
              <div v-else class="upload-img" style="cursor: pointer" @click="clickUpload(2)">
                <img src="../../../assets/newImage/addImg.png" alt="" style="height: 50px; width: 60px;">
              </div>
              <input ref="imgInput2" style="display: none" type="file" accept="image/jpeg,image/png"
                @change="changeImg($event, 2)" multiple="multiple" />
            </div>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[5]">
            {{ checkImgMsg }}
          </div>
        </div>
      </div>
      <div class="form_box_item">
        <div class="item_title">{{ $t('register.contact_information') }}</div>
        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t('register.name') }}</span>
          </div>
          <div>
            <el-input v-model="registerForm.name" @input="checkRegisterInfo(6)"
              :placeholder="$t('register.enter_real_name')" clearable></el-input>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[6]">
            {{ checkNameMsg }}
          </div>
        </div>

        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t('register.phone_number') }}</span>
          </div>
          <div>
            <el-input v-model="registerForm.phone" @input="checkRegisterInfo(7)"
              :placeholder="$t('register.enter_common_phone')" clearable></el-input>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[7]">
            {{ checkPhoneMsg }}
          </div>
        </div>

        <div class="item_form" :class="isLang ? 'english' : ''">
          <div>
            <span class="icon">*</span>
            <span class="item_form_label">{{ $t('register.mailbox') }}</span>
          </div>
          <div>
            <el-input v-model="registerForm.email" @input="checkRegisterInfo(8)"
              :placeholder="$t('register.enter_common_mailbox')" clearable></el-input>
          </div>
          <div style="margin-left: 30px;color:red;" v-show="showWaring && !showWaringList[8]">
            {{ checkEmailMsg }}
          </div>
        </div>
      </div>
    </div>
    <div class="form_box_item" style="border: none;padding: 20px 0;">
      <el-checkbox v-model="agree"></el-checkbox>
      <span style="margin-left: 10px;color: #adadad;">
        {{ $t('register.already_read') }}
        <span style="color: #1e50f0;cursor: pointer;" @click="$router.push('/TermsofService')">{{
          $t('register.terms_of_ervice') }}</span>
        {{ $t('register.and') }}
        <span style="color: #1e50f0;cursor: pointer;" @click="$router.push('/TermsofService')">{{
          $t('register.privacy_policy') }}</span>
      </span>
      <div style="text-align: center">
        <b2b-button class="submit_btn" @click="submit">{{
          $t('register.submit_registration')
        }}</b2b-button>
      </div>
    </div>


  </div>
</template>

<script>
import Crumbs from './components/Crumbs.vue'
export default {
  data () {
    return {
      registerForm: {
        city: ''
      },
      countries: [],
      provinces: [],
      cities: [],
      imgUrl1: '',
      imgUrl2: '',
      imgFile1: {},
      imgFile2: {},
      showWaring: false,
      showWaringList: [false, false, false, false, false, false, false, false, false],
      checkLoginNameMsg: this.$t("register.enter_user_name"),
      checkpPasswordMsg: this.$t('register.enter_password'),
      checkpPasswordMsg2: this.$t('register.enter_confirm_password'),
      checkCompanyMsg: this.$t('register.enter_company_name'),
      checkNameMsg: this.$t('register.enter_name'),
      checkPhoneMsg: this.$t('register.enter_phone_number'),
      checkEmailMsg: this.$t('register.enter_mailbox'),
      checkCityMgs: this.$t('register.sel_city'),
      checkImgMsg: this.$t('register.upload_business_license'),
      agree: false,
      isClickBtn: false
    }
  },
  components: {
    Crumbs
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const { body: result } = await this.$http.get('/static/mock/cityData.json')
      this.countries = result
      this.provinces = this.countries[0].children
    },
    checkRegisterInfo (type) {
      if (type == 0) {
        const regExp = /^[A-Za-z0-9]+$/
        if (!this.registerForm.loginName) {
          this.checkLoginNameMsg = this.$t("register.enter_user_name")
          this.showWaringList[0] = false
          return
        }
        if (!regExp.test(this.registerForm.loginName)) {
          this.checkLoginNameMsg = '英文和数字组成！'
          this.showWaringList[0] = false
          return
        }
        if (this.registerForm.loginName.length > 24) {
          this.checkLoginNameMsg = '不能超过24个字符'
          this.showWaringList[0] = false
          return
        }
        this.showWaringList[0] = true
      }
      if (type == 1) {
        if (!this.registerForm.password) {
          this.checkpPasswordMsg = this.$t('register.enter_password')
          this.showWaringList[1] = false
          return
        }
        const regexp = /^[a-zA-Z]/
        let password = this.registerForm.password
        if (!regexp.test(password)) {
          this.checkpPasswordMsg = '必须以字母开头'
          this.showWaringList[1] = false
          return
        }
        if (password.length < 6 || password.length > 20) {
          this.checkpPasswordMsg = '密码6-20位组成'
          this.showWaringList[1] = false
          return
        }
        this.showWaringList[1] = true
      }
      if (type == 1 || type == 2) {
        if (!this.registerForm.confirmPassword) {
          this.checkpPasswordMsg2 = this.$t('register.enter_confirm_password')
          this.showWaringList[2] = false
          return
        }
        if (this.registerForm.confirmPassword != this.registerForm.password) {
          this.checkpPasswordMsg2 = '两次密码输入不一致'
          this.showWaringList[2] = false
          return
        }
        this.showWaringList[2] = true
      }
      if (type == 3) {
        if (!this.registerForm.companyName) {
          this.checkCompanyMsg = this.$t('register.enter_company_name')
          this.showWaringList[3] = false
          return
        }
        this.showWaringList[3] = true
      }
      if (type == 4) {
        if (!this.registerForm.country && !this.registerForm.province && !this.registerForm.city) {
          this.checkCityMgs = this.$t('register.sel_city')
          this.showWaringList[4] = false
          return
        }
        this.showWaringList[4] = true
      }
      if (type == 5) {
        if (!this.imgUrl2) {
          this.checkImgMsg = this.$t('register.upload_business_license')
          this.showWaringList[5] = false
          return
        }
        this.showWaringList[5] = true
      }
      if (type == 6) {
        if (!this.registerForm.name) {
          this.checkNameMsg = this.$t('register.enter_name')
          this.showWaringList[6] = false
          return
        }
        this.showWaringList[6] = true
      }
      if (type == 7) {
        if (!this.registerForm.phone) {
          this.checkPhoneMsg = this.$t('register.enter_phone_number')
          this.showWaringList[7] = false
          return
        }
        this.showWaringList[7] = true
      }
      if (type == 8) {
        if (!this.registerForm.email) {
          this.checkEmailMsg = this.$t('register.enter_mailbox')
          this.showWaringList[8] = false
          return
        }
        let emailReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9_-]+\.([a-zA-Z]{2,4})$/
        if (!emailReg.test(this.registerForm.email)) {
          this.checkEmailMsg = '请输入正确的邮箱'
          this.showWaringList[8] = false
          return
        }
        this.showWaringList[8] = true
      }
    },
    changeCity (val, type) {
      if (type == 1) {
        for (let i = 0; i < this.countries.length; i++) {
          let countryData = this.countries[i]
          if (countryData.label == val) {
            this.provinces = countryData.children
            this.registerForm.province = ''
            this.registerForm.city = ''
            break
          }
        }
      } else if (type == 2) {
        for (let i = 0; i < this.provinces.length; i++) {
          let provinData = this.provinces[i]
          if (provinData.label == val) {
            this.cities = provinData.children
            this.registerForm.city = ''
            break
          }
        }
      }
    },
    closeImg (index) {
      if (index == 1) {
        this.imgUrl1 = ''
        this.$refs.imgInput1.value = ''
      } else if (index == 2) {
        this.imgUrl2 = ''
        this.$refs.imgInput2.value = ''
      }
      this.checkRegisterInfo(5)
    },
    clickUpload (index) {
      if (index == 1) {
        this.$refs.imgInput1.click()
      } else if (index == 2) {
        this.$refs.imgInput2.click()
      }
    },
    changeImg (e, index) {
      if (e.target.files.length == 0) {
        return
      }
      let file = e.target.files[0]
      if (file.type != 'image/jpeg' && file.type != 'image/png') {
        this.closeImg(index)
        this.$message.warning('请上传jpg/png格式。')
        return
      }
      if (file.size > 5 * 1024 * 1000) {
        this.closeImg(index)
        this.$message.warning('图片大小不超5M。')
        return
      }
      if (index == 1) {
        this.imgUrl1 = window.URL.createObjectURL(file)
        this.imgFile1 = file
      } else if (index == 2) {
        this.imgUrl2 = window.URL.createObjectURL(file)
        this.imgFile2 = file
        this.checkRegisterInfo(5)
      }
    },
    submit () {
      this.showWaring = true
      let formCheck = this.showWaringList.every(item => item)
      if (formCheck) {
        if (!this.agree) {
          this.$message.warning('请阅读并同意《服务条款》及《隐私政策》')
        } else {
          this.toRegister()
        }
      }
    },
    async toRegister () {
      this.isClickBtn = true
      this.registerForm['mobile'] = this.registerForm.phone
      this.registerForm.region = this.registerForm.country + '-' + this.registerForm.province + '-' + this.registerForm.city
      let reqData = new FormData()
      reqData.append('partnerInfo', JSON.stringify(this.registerForm))
      reqData.append('imgTwo', this.imgFile2)
      const { body: result } = await this.$http.post('/b2b/register', reqData)
      this.isClickBtn = false
      if (result.code != 200) return this.$message.error(result.message)
      this.$router.push('success')
    }
  },
  computed: {
    isLang () {
      return localStorage.getItem('lang') == 'en'
    }
  }
}
</script>

<style lang="less" scoped>
.form_box {
  width: 100%;
  font-family: '微软雅黑';
  margin-bottom: 80px;

  .form_box_item {
    margin: auto;
    width: 937px;
    border: 1px solid #f2f2f2;
    border-collapse: collapse;
    padding: 20px;

    .item_title {
      font-size: 18px;
      font-weight: bold;
    }

    .item_form {
      display: grid;
      grid-template-columns: 80px 380px 1fr;
      align-items: center;
      padding: 20px 0 0 60px;

      .icon {
        color: #1e50f0;
      }

      .item_form_label {
        font-size: 14px;
        font-weight: 400;
      }

      .city_sel_group {
        display: grid;
        grid-template-columns: repeat(3, 120px);
        grid-column-gap: 10px;
      }
    }

    .item_form.english {
      grid-template-columns: 135px 380px 1fr;
    }

    .submit_btn {
      margin-top: 20px;
      font-size: 18px;
      font-weight: 500;
      width: 50%;
    }
  }

  .upload-div {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 5px;
  }

  .upload-img {
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
    object-fit: cover;
    background-color: #f1f3f7;
  }

  .close-img-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    color: #b8b5b5;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/newPages/login/registerForm.vue